import { render, staticRenderFns } from "./ViewSelaaTabs.vue?vue&type=template&id=7fb955f3&scoped=true&"
import script from "./ViewSelaaTabs.vue?vue&type=script&lang=js&"
export * from "./ViewSelaaTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb955f3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb955f3')) {
      api.createRecord('7fb955f3', component.options)
    } else {
      api.reload('7fb955f3', component.options)
    }
    module.hot.accept("./ViewSelaaTabs.vue?vue&type=template&id=7fb955f3&scoped=true&", function () {
      api.rerender('7fb955f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ViewSelaaTabs.vue"
export default component.exports